export const tmaisUsersDefaultColumns = [
  { label: 'Nome', value: 'full_name' },
  { label: 'Município', value: 'city' },
  { label: 'Email', value: 'email' },
  { label: 'Telefone', value: 'phone' },
  { label: 'Ações', value: 'action', className: 'w-11' },
];
